import React, {useState, useEffect, useContext} from "react";
import {Link, useLocation, useHistory} from "react-router-dom";
import silvercrossLogo from "../../assets/svg/silvercross.svg";
import {productCategories} from "../App";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isHovered, setHovered] = useState(false);

  const location = useLocation();
  const history = useHistory();
  const {pathname} = location;
  const splitLocation = pathname.split("/");
  const {categories} = useContext(productCategories);

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    setMenuOpen(false); // close menu when any link is clicked
    setHovered(false); // also close dropdown if open
  };

  return (
    <div>
      {/* ...top bar code... */}

      <header className={`page_header header_white section_padding_25 ${menuOpen ? "mobile-active" : ""}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 display_table">
              <div className="header_left_logo display_table_cell">
                <div
                  onClick={() => {
                    history.push("/");
                    handleLinkClick();
                  }}
                  className="logo top_logo"
                  style={{cursor: "pointer"}}>
                  <img className="carin_logo" src={"https://d3ovr3jl9wbjnk.cloudfront.net/assets/silvercross.svg"} alt="" />
                </div>
              </div>

              <div className="header_mainmenu display_table_cell text-center">
                <nav className={`mainmenu_wrapper ${menuOpen ? "mobile-active" : ""}`}>
                  <ul className="mainmenu nav sf-menu">
                    <li className={splitLocation[1] === "" ? "active" : ""}>
                      <Link className="sf-with-ul" to="/" onClick={handleLinkClick}>
                        Home
                      </Link>
                    </li>
                    <li className={splitLocation[1] === "about" ? "active" : ""}>
                      <Link to="/about" onClick={handleLinkClick}>
                        About Us
                      </Link>
                    </li>
                    <li onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} className={splitLocation[1] === "offerings" ? (isHovered ? "active sfHover" : "active") : isHovered ? "sfHover" : ""}>
                      <Link className="sf-with-ul" to="/offerings" onClick={handleLinkClick}>
                        Our Offerings
                      </Link>
                      <ul style={isHovered ? {display: "block", marginTop: 0} : {display: "none", marginTop: "5px"}}>
                        {categories.map((data) => (
                          <li key={data.id}>
                            <Link to={`/offerings/${data.category}?id=${data.id}`} onClick={handleLinkClick}>
                              {data.category}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                    <li className={splitLocation[1] === "community" ? "active" : ""}>
                      <Link to="/community" onClick={handleLinkClick}>
                        Our Reach
                      </Link>
                    </li>
                    <li className={splitLocation[1] === "careers" ? "active" : ""}>
                      <Link to="/careers" onClick={handleLinkClick}>
                        Careers
                      </Link>
                    </li>
                    <li className={splitLocation[1] === "contact" ? "active" : ""}>
                      <Link to="/contact" onClick={handleLinkClick}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                </nav>

                {/* hamburger button */}
                <span className={`toggle_menu ${menuOpen ? "mobile-active" : ""}`} onClick={handleMenuToggle}>
                  <span></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
